import { render, staticRenderFns } from "./HowManyPeopleWorkInTheCompany.vue?vue&type=template&id=46e75364&scoped=true&"
import script from "./HowManyPeopleWorkInTheCompany.vue?vue&type=script&lang=js&"
export * from "./HowManyPeopleWorkInTheCompany.vue?vue&type=script&lang=js&"
import style0 from "./HowManyPeopleWorkInTheCompany.vue?vue&type=style&index=0&id=46e75364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e75364",
  null
  
)

export default component.exports